var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("div", [
              _c("div", [
                _vm._v("\n          当前版本:"),
                _c("span", { staticClass: "v" }),
                _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.version || "Tuoluojiang")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info title mt20" }, [
                _vm._v("\n          更新说明：\n          "),
                !_vm.status
                  ? _c("span", [_vm._v("已升级至最新版本，无需更新")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.status
                  ? _c("ul", [
                      _c("li", [
                        _vm._v(
                          "V" +
                            _vm._s(_vm.info.first_version) +
                            "." +
                            _vm._s(_vm.info.second_version) +
                            "." +
                            _vm._s(_vm.info.third_version)
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.status
              ? _c(
                  "el-button",
                  {
                    staticClass: "primary btn update",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.update()
                      },
                    },
                  },
                  [_vm._v("立即升级")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "mt20 employees-card" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "系统升级", name: "first" } },
                [
                  _c(
                    "el-timeline",
                    { staticClass: "ml20" },
                    _vm._l(_vm.activities, function (item, index) {
                      return _c(
                        "el-timeline-item",
                        { key: index, staticClass: "time-line mt20" },
                        [
                          _c("div", { staticClass: "time" }, [
                            _vm._v(_vm._s(item.release_time)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-collapse",
                            {
                              on: { change: _vm.handleChange },
                              model: {
                                value: index,
                                callback: function ($$v) {
                                  index = $$v
                                },
                                expression: "index",
                              },
                            },
                            [
                              _c("el-collapse-item", { attrs: { name: 0 } }, [
                                _c(
                                  "div",
                                  {
                                    class:
                                      index == 0 ? "active-line" : "title-line",
                                    attrs: { slot: "title" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.judgeActive(index)
                                      },
                                    },
                                    slot: "title",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.title) +
                                        " v" +
                                        _vm._s(item.first_version) +
                                        "." +
                                        _vm._s(item.second_version) +
                                        "." +
                                        _vm._s(item.third_version) +
                                        "\n                  "
                                    ),
                                    _c("i", {
                                      class:
                                        _vm.activeNames === index &&
                                        _vm.isActive === 2
                                          ? "el-icon-arrow-up"
                                          : " el-icon-arrow-down",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("ul", { staticClass: "content ml20" }, [
                                  _c("li", {
                                    staticClass: "content-li",
                                    domProps: {
                                      innerHTML: _vm._s(item.content),
                                    },
                                  }),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.activities.length == 0
                    ? _c("div", { staticClass: "defult" }, [
                        _c("img", {
                          staticClass: "img",
                          attrs: {
                            src: require("@/assets/images/def2.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text" }, [
                          _vm._v("暂无系统升级～"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "升级记录", name: "second" } },
                [
                  _vm.logActivities.length > 0
                    ? _c(
                        "el-timeline",
                        { staticClass: "ml20" },
                        _vm._l(_vm.logActivities, function (item, index) {
                          return _c(
                            "el-timeline-item",
                            { key: index, staticClass: "time-line mt20" },
                            [
                              _c("div", { staticClass: "time" }, [
                                _vm._v(_vm._s(item.upgrade_time)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-collapse",
                                {
                                  on: { change: _vm.handleChange },
                                  model: {
                                    value: index,
                                    callback: function ($$v) {
                                      index = $$v
                                    },
                                    expression: "index",
                                  },
                                },
                                [
                                  _c(
                                    "el-collapse-item",
                                    { attrs: { name: 0 } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          class:
                                            index == 0
                                              ? "active-line"
                                              : "title-line",
                                          attrs: { slot: "title" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.judgeActive(index)
                                            },
                                          },
                                          slot: "title",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.title) +
                                              " v" +
                                              _vm._s(item.first_version) +
                                              "." +
                                              _vm._s(item.second_version) +
                                              "." +
                                              _vm._s(item.third_version) +
                                              "\n\n                  "
                                          ),
                                          _c("i", {
                                            class:
                                              _vm.activeNames === index &&
                                              _vm.isActive === 2
                                                ? "el-icon-arrow-up"
                                                : " el-icon-arrow-down",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "content ml20" },
                                        [
                                          _c("li", {
                                            staticClass: "content-li",
                                            domProps: {
                                              innerHTML: _vm._s(item.content),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.logActivities.length == 0
                    ? _c("div", { staticClass: "defult" }, [
                        _c("img", {
                          staticClass: "img",
                          attrs: {
                            src: require("@/assets/images/def2.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text" }, [
                          _vm._v("暂无升级记录哟～"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.exoneration,
            width: "672px",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.exoneration = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog1" }, [
            _c("div", { staticClass: "exoneration-header" }, [
              _vm._v("免责声明"),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "dialog1-content",
              domProps: { innerHTML: _vm._s(_vm.agreemen.content) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _c("div", { staticClass: "btn", on: { click: _vm.refuse } }, [
                _vm._v("拒绝"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn2", on: { click: _vm.agree } }, [
                _vm._v("同意"),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.upgrade,
            width: "380px",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.upgrade = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog d-upgrade" },
            [
              _c("div", { staticClass: "img" }, [
                _vm._v("升级至v" + _vm._s(_vm.infoUpgrade)),
              ]),
              _vm._v(" "),
              _vm.upgradeProgress.speed != "100.0" ||
              this.downloadStatus != "200"
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "progress" },
                      [
                        _c("el-progress", {
                          attrs: {
                            type: "circle",
                            percentage: Number(_vm.upgradeProgress.speed),
                            format: _vm.format,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c("div", { staticClass: "circle" }, [
                        _vm._v(_vm._s(_vm.upgradeProgress.speed) + "%"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("正在更新，请耐心等待 ~"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.upgradeProgress.speed == "100.0"
                ? [
                    _c("img", {
                      staticClass: "ok-img",
                      attrs: {
                        src: require("@/assets/images/ok.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ok-text" }, [_vm._v("升级成功")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ok-btn mt20",
                        attrs: { type: "primary", round: "" },
                        on: { click: _vm.back },
                      },
                      [_vm._v("确认")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }